export default __webpack_public_path__ + "static/media/youngfemale.728ad972.svg";